//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import Vue from 'vue'
// var VueCookie = require('vue-cookie');

 import VueCookie from 'vue-cookie';
// Tell Vue to use the plugin
Vue.use(VueCookie);



// const ADD_URL = URL_APP + "api/v1/rincian_obyek/";
  import GoogleLogin from 'vue-google-login';
  import googleOneTap from 'google-one-tap';
  import VueJwtDecode from 'vue-jwt-decode'



  import { Notify  } from 'quasar'
  import Joi from "joi";

  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
    password: Joi.string().min(6).required(),
  });


  export default {
    name: "monev_login",
    components: {
      // GoogleLogin,
    },
    data : function(){
      return {

          errorMessage: '',
          user : {
            username : "",
            password : ""
          },
          params: {

              client_id: '125938679529-ls5r57f6sve7rebfts0h5v6qrqj430cc.apps.googleusercontent.com' // local
              // client_id: "125938679529-ju2n7u8jibs6asfheap35obmjdsu5svp.apps.googleusercontent.com" // server
          },

          renderParams: {
              width: 250,
              height: 50,
              longtitle: true
          },

          url : {
            LOGIN_URL : this.$store.state.url.URL_APP + "auth/login",

          }
      }
    },
    
    methods: {
      // onSuccess(googleUser) {


      //     console.log(googleUser);

      //     // This only gets the user information: id, name, imageUrl and email
      //     // console.log(googleUser.getBasicProfile());



      //     var datax = googleUser.getBasicProfile()

      //     // console.log(datax)


         



      //     const useremail = {
      //       id : datax[Object.keys(datax)[0]],
      //       nama : datax[Object.keys(datax)[1]],
      //       email : datax[Object.keys(datax)[5]],
      //       foto : datax[Object.keys(datax)[4]],


      //     }

      //     // console.log(useremail)

      //     console.log('0 = '+ Object.keys(datax)[0])
      //     console.log('1 = '+ Object.keys(datax)[1])
      //     console.log('2 = '+ Object.keys(datax)[2])
      //     console.log('3 = '+ Object.keys(datax)[3])
      //     console.log('4 = '+ Object.keys(datax)[4])
      //     console.log('5 = '+ Object.keys(datax)[5])
      //     console.log('6 = '+ Object.keys(datax)[6])
      //     console.log('7 = '+ Object.keys(datax)[7])


      //     fetch(this.url.LOGIN_URL, {
      //       method : 'POST',
      //       headers : {
      //         'content-type' : 'application/json',
      //       },
      //       body : JSON.stringify(useremail),
      //     }).then((response) => {
            
      //       console.log(response);
            
      //           if (response.ok) {
      //               return response.json();
      //               this.$store.commit("shoWLoading");
      //           }

      //           return response.json().then(error => {
      //               throw new Error(error.message);
      //               this.$store.commit("shoWLoading");
      //           });
      //       })
      //       .then((result) => {
      //         console.log("=============================");
      //         // console.log(result);
      //         // menyimpan token yang tergenerate dari server
      //         localStorage.token = result.token;
      //         localStorage.profile = JSON.stringify(result.profile);
      //         setTimeout(() => {
      //           this.$store.commit("hideLoading")
      //           this.$store.commit("getStorage")
      //           this.$router.push('/kuesioner');
      //         }, 1000);
      //       })
      //       .catch(error => {
      //         setTimeout(() => {
      //           this.$store.commit("hideLoading")
      //           this.errorMessage = error.message;
      //         }, 1000);
      //       });



      // },

      // onFailure(errx){
      //   console.log(errx)
      //   console.log('gagal')
      // },

      loginInGoogle(){
        this.$cookie.delete('g_state');



        // const options = {
        //   client_id: '323814966941-eg4kmi2d9ooihbnsd4oau70n1s9i2plp.apps.googleusercontent.com', // required
        //   auto_select: false, // optional
        //   cancel_on_tap_outside: false, // optional
        //   context: 'signin', // optional
        //   ux_mode : "popup",
        // };
        // googleOneTap(options, (response) => {

        //   // Send response to server
        //   console.log(response);
        //   // const responsePayload = decodeJwtResponse(response.credential)
        // });



        location.reload();
      },

    },




    mounted : function(){

      // this.$cookie.set('g_state', 'Hello world!', 1);
      this.$cookie.delete('g_state');







      const options = {
        // client_id: '323814966941-eg4kmi2d9ooihbnsd4oau70n1s9i2plp.apps.googleusercontent.com', // required
        client_id: "323814966941-qad711ohhp92h6nme5m6h3q97fdjj8eh.apps.googleusercontent.com", // server
        auto_select: false, // optional
        cancel_on_tap_outside: false, // optional
        context: 'signin', // optional
      };
      googleOneTap(options, (response) => {
        
        // Send response to server
        console.log(response);
        // const responsePayload = decodeJwtResponse(response.credential)
        const test = VueJwtDecode.decode(response.credential)
        console.log(test.email)
        console.log(test)







          const useremail = {
            id : test.email,
            nama : test.name,
            email : test.email,
            foto : test.picture,


          }




          this.$store.commit("shoWLoading");

          fetch(this.url.LOGIN_URL, {
            method : 'POST',
            headers : {
              'content-type' : 'application/json',
            },
            body : JSON.stringify(useremail),
          }).then((response) => {
            
            console.log(response);
            
                if (response.ok) {
                    return response.json();
                    this.$store.commit("shoWLoading");
                }

                return response.json().then(error => {
                    throw new Error(error.message);
                    this.$store.commit("shoWLoading");
                });
            })
            .then((result) => {
              console.log("=============================");
              // console.log(result);
              // menyimpan token yang tergenerate dari server
              localStorage.token = result.token;
              localStorage.profile = JSON.stringify(result.profile);
              setTimeout(() => {
                this.$store.commit("hideLoading")
                this.$store.commit("getStorage")
                this.$router.push('/kuesioner');
              }, 1000);
            })
            .catch(error => {
              setTimeout(() => {
                this.$store.commit("hideLoading")
                this.errorMessage = error.message;
              }, 1000);
            });



































      });
      
      

    },
  };
